import {
  Card,
  Fieldset,
  Heading,
  Paragraph,
  Radio,
} from "@digdir/designsystemet-react";
import type { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TranslatedValidationMessage } from "@/components";
import {
  type bestillerSelskapFormValues,
  translationPrefixSelskapForm,
} from "../bestillinger/forms";
import { Constants } from "./constants";

type SelskapBoligTypeFieldsProps = {
  form: UseFormReturn<bestillerSelskapFormValues>;
};

export const SelskapBoligTypeFields = ({
  form,
}: SelskapBoligTypeFieldsProps) => {
  const { t } = useTranslation();

  return (
    <Fieldset>
      <Fieldset.Legend>
        {t(`${translationPrefixSelskapForm}.felt`, {
          context: "boligType",
        })}
      </Fieldset.Legend>
      <div className="flex flex-wrap gap-4">
        {Constants.SELSKAPS_BOLIGTYPER.map((orgType) => (
          <Card
            variant="default"
            key={orgType}
            className="p-4 w-full border-balder-border-default"
          >
            <Radio
              label={
                <div className="font-normal">
                  <Heading data-size={"xs"} className="text-lg">
                    {t(`${translationPrefixSelskapForm}.boligType.tittel`, {
                      context: orgType,
                    })}
                  </Heading>
                  <Paragraph className="text-base text-balder-text-subtle">
                    {t(
                      `${translationPrefixSelskapForm}.boligType.beskrivelse`,
                      {
                        context: orgType,
                      },
                    )}
                  </Paragraph>
                </div>
              }
              value={orgType}
              {...form.register("boligType")}
              name="boligType"
            />
          </Card>
        ))}
      </div>
      <TranslatedValidationMessage error={form.formState.errors.boligType} />
    </Fieldset>
  );
};
